import React, { useEffect } from 'react'
import Additional from './Additional'
import Comment from './Comment'

const Sql = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  }, []);

  return (
    <div>
    <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container py-5">
    <div className="row g-5">
      <div className="col-lg-8">
        {/* Blog Detail Start */}
        <div className="mb-5">
          <h1 className="mb-4">What will I learn in this course?</h1>
          <ul>
            <li>Getting Started with SQL Server</li>
            <li>T-SQL Fundamentals with SQL Server</li>
            <li>SQL Server Views and Indexes</li>
            <li>SQL Server Stored Procedures and Functions</li>
            <li>SQL Server Triggers and Cursors</li>
            <li>Understanding and Managing Azure SQL Database</li>
          </ul>
          <p><b>Session 1: Getting Started with SQL Server</b></p>
          <p>Introduction to Database,Introduction to SQL Server,Installing SQL Server and Components,SQL Server Database and Tables,SQL Keys,SQL Commands,SQL Constraints,Types of Database</p>
          <p><b>Session 2: T-SQL Fundamentals with SQL Server</b></p>
          <p>Data Types, Variables and Operators, SQL Server Control Of Flow,SQL Query and Sub Query,SQL Clauses,SQL Predicates,SQL Joins,SQL Exceptions,Try..Catch</p>
          <p><b>Session 3: SQL Server Views and Indexes</b></p>
          <p>SQL Server Views,Types of Views,SQL Sever Indexes,Types of Indexes</p>
          <p><b>Session 4: SQL Server Stored Procedures and Functions</b></p>
          <p>Introduction to Stored Procedure,Types of Stored Procedure,Creating Stored Procedures For Insert, Update and Delete, Stored Procedures Parameters,SQL Server Functions,Scalar Functions,Table Valued Functions</p>
          <p><b>Session 5: SQL Server Triggers and Cursors</b></p>
          <p>SQL Server Triggers,Types of Triggers,SQL Server Cursors,Types of Cursors,Cursor Alternatives</p>
          <p><b>Session 6: Understanding and Managing Azure SQL Database</b></p>
          <p>Introduction to Azure SQL Database,Database Deployment Models,Azure SQL Database Server,Creating and Managing Single Database,Purchasing Models: DTU and vCore,Azure SQL Database Tools,Database Migration Using DMA,Creating and Managing Elastic Pool,Creating Managed Instance</p>
        </div>
        {/* Blog Detail End */}
        {/* Comment List Start */}
        <Comment/>
        {/* Comment Form End */}
      </div>
      {/* Sidebar Start */}
      <div className="col-lg-4">
        {/* Search Form Start */}
        <Additional/>
        {/* Plain Text End */}
      </div>
      {/* Sidebar End */}
    </div>
  </div>
</div>

    </div>
  )
}

export default Sql